import { Action } from "redux";

const initialState = {
  locale: 'en-US',
}

export default (state = initialState, action: Action) => {
  switch (action.type) {

    default:
      return state
  }
}